import React, { useEffect, useState } from "react";
import axios from "axios";
import "./Career.css";
import {
  FaUsers,
  FaRocket,
  FaHandshake,
  FaMapMarkerAlt,
  FaClock,
  FaLightbulb,
  FaChalkboardTeacher,
  FaCheckCircle,
} from "react-icons/fa";
import { CSSTransition } from "react-transition-group";
import images from "../../constants/images";
import LifeOfGalaxyChain from "../../components/lifeofgalaxychain/LifeOfGalaxyChain";
import { ACCEPT_HEADER, apply_form, get_career_data, get_current_opening } from "../../utils/constants";
import Notification from "../../utils/Notification";


const Career = () => {
  const [careerDetails, setcareerDetails] = useState();
  const [currentOpening, setCurrentOpening] = useState([]);
  const [loading, setLoading] = useState(true);

  const [modalOpen, setModalOpen] = useState(false);
  const [selectedJob, setSelectedJob] = useState("");
  const [selectedJobName, setSelectedJobName] = useState("");
  const [formData, setFormData] = useState({
    name: "",
    number: "",
    wnumber: "",
    email: "",
    resume: null,
  });

  // ✅ Fetch job openings from API
  useEffect(() => {
    window.scrollTo(0, 0);
    fetchJobData();
    currentOpeningData();
  }, []);

  const fetchJobData = async () => {
    try {
      const res = await axios.get(
        get_career_data, {
        headers: {
          Accept: ACCEPT_HEADER,
        },
      }
      );
      if (res.data?.success == 1) {
        setcareerDetails(res.data.data); // adjust based on API response structure
      } else {
        console.error("No job data found");
      }
    } catch (error) {
      console.error("Error fetching job openings:", error);
    } finally {
      setLoading(false);
    }
  };

  const currentOpeningData = async () => {
    try {
      const res = await axios.get(
       get_current_opening, {
        headers: {
          Accept: ACCEPT_HEADER,
        },
      }
      );
      if (res.data?.success == 1) {
        setCurrentOpening(res.data.data); // adjust based on API response structure
      } else {
        console.error("No Current Opening data found");
      }
    } catch (error) {
      console.error("Error Current Opening data openings:", error);
    } finally {
      setLoading(false);
    }
  };

const openModal = (jobId,jobname) => {
  setSelectedJob(jobId);
  setSelectedJobName(jobname);
  setModalOpen(true);
};


  const closeModal = () => {
    setModalOpen(false);
    setFormData({ name: "", number: "", email: "", wnumber: "", resume: null });
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (
      file &&
      ![
        "application/pdf",
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      ].includes(file.type)
    ) {
       Notification(
                "warning",
                "Warning!",
                "Only PDF or DOC/DOCX files are allowed."
              );
      return;
    }
    setFormData({ ...formData, resume: file });
  };

const handleSubmit = async (e) => {
  e.preventDefault();

  if (!selectedJob) {
    Notification(
                "warning",
                "Warning!",
                "No job selected."
              );
    return;
  }

  try {
    const form = new FormData();
    form.append("current_opening_id", selectedJob); // make sure this matches API requirement
    form.append("full_name", formData.name);
    form.append("contact_number", formData.number);
    form.append("whatsapp_number", formData.wnumber);
    form.append("email", formData.email);
    form.append("resume", formData.resume);

    const res = await axios.post(
      apply_form,
      form,
      {
        headers: {
          Accept: ACCEPT_HEADER,
        },
      }
    );

    if (res.data?.success === 1) {
      Notification(
                "success",
                "Success!",
                res.data.message || "Application submitted successfully!"
              );
      closeModal();
    } else {
      Notification(
                "warning",
                "Warning!",
                res.data?.message || "Failed to submit application."
              );
    }
  } catch (error) {
    console.error("Error submitting application:", error);
     Notification(
                "warning",
                "Warning!",
                "Something went wrong while submitting the application"
              );
  }
};


  console.log("currentOpening",careerDetails);
  

  return (
    <div className="career-page">
      {/* Hero */}
      <section className="hero">
        <h1>{careerDetails?.title}</h1>
        <p>
          {careerDetails?.sub_title}
        </p>
        <a href="#openings" className="btn-primary">
          View Openings
        </a>
      </section>

      {/* Culture */}
      <section className="culture">
        <h2>Why Work With Us?</h2>
        <div className="underline"></div>
        <div className="culture-grid">
          <div className="culture-item">
            <FaUsers />
            <p>Collaborative Culture</p>
          </div>
          <div className="culture-item">
            <FaRocket />
            <p>Career Growth</p>
          </div>
          <div className="culture-item">
            <FaHandshake />
            <p>Employee Respect</p>
          </div>
          <div className="culture-item">
            <FaMapMarkerAlt />
            <p>Global Presence</p>
          </div>
          <div className="culture-item">
            <FaClock />
            <p>Work-Life Balance</p>
          </div>
          <div className="culture-item">
            <FaLightbulb />
            <p>Innovation-Driven</p>
          </div>
          <div className="culture-item">
            <FaChalkboardTeacher />
            <p>Skill Development</p>
          </div>
        </div>
      </section>

      {/* Life of Galaxy Chain */}
      <LifeOfGalaxyChain careerDetails = {careerDetails}/>

      {/* Openings */}
      <section id="openings" className="openings">
        <h2>Current Openings</h2>
        <div className="underline"></div>

        {loading ? (
          <p>Loading job openings...</p>
        ) : currentOpening.length === 0 ? (
          <p>No openings available at the moment.</p>
        ) : (
          <div className="job-list">
            {currentOpening.map((job) => (
              <div key={job.id} className="job-card">
                <div className="job-info">
                  <h3>{job?.positions?.name}</h3>
                  <p className="job_info_desc">{job.remark}</p>

                  {job.position_type_id && (
                    <ul className="job-skills">
                      {job.position_type_id.map((skill, index) => (
                        <li key={index}>
                          <FaCheckCircle
                            style={{ fontSize: "12px", color: "#002B66" }}
                          />
                          {skill}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
                <div className="job_button_part">
                  <p className="job_info_add">
                    {job.location} | {job.timing} | {job.experience}
                  </p>
                  <button
  className="btn-secondary"
  onClick={() => openModal(job.position_id,job.positions.name)}
>
  Apply Now
</button>

                </div>
              </div>
            ))}
          </div>
        )}
      </section>

      {/* CTA */}
      <section className="cta">
        <h2>Don't see a role that fits?</h2>
        <p>
          We're always looking for talented people. Send your resume to{" "}
          <strong>hr@galaxychains.com</strong>
        </p>
        <p>
          Whether you're starting your career or bringing years of expertise,
          Galaxy Chains offers opportunities to contribute meaningfully and
          evolve professionally.
        </p>
        <a href="mailto:hr@galaxychains.com" className="btn-primary">
          Send Resume
        </a>
      </section>

      {/* Modal */}
      <CSSTransition
        in={modalOpen}
        timeout={300}
        classNames="fade"
        unmountOnExit
      >
        <div className="modal-backdrop" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <h3>Apply for: {selectedJobName}</h3>
            <form onSubmit={handleSubmit} encType="multipart/form-data">
              <input
                type="text"
                name="name"
                placeholder="Your Name"
                value={formData.name}
                onChange={handleChange}
                required
              />
              <input
                type="tel"
                name="number"
                placeholder="Phone Number"
                value={formData.number}
                onChange={handleChange}
                required
              />
              <input
                type="tel"
                name="wnumber"
                placeholder="WhatsApp Number"
                value={formData.wnumber}
                onChange={handleChange}
              />
              <input
                type="email"
                name="email"
                placeholder="Email"
                value={formData.email}
                onChange={handleChange}
                required
              />
              <label className="file-label">
                Upload Resume (PDF or DOC):
                <input
                  type="file"
                  accept=".pdf,.doc,.docx"
                  onChange={handleFileChange}
                  required
                />
              </label>
              {formData.resume && (
                <p className="file-name">Selected: {formData.resume.name}</p>
              )}
              <button type="submit" className="btn-primary full-width">
                Submit Application
              </button>
              <button type="button" className="btn-cancel" onClick={closeModal}>
                Cancel
              </button>
            </form>
          </div>
        </div>
      </CSSTransition>
    </div>
  );
};

export default Career;
